import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { infoCategoria, infoTextCategoria } from '../../actions/configFormularioAction';
import { uiFinalitzarFormularioAction, esborrarErrorAction, esborrarOkAction } from '../../actions/ui';
import { FormularioCat } from './FormularioCat';

const CATS = [
  { num: 1, color: 'var(--color-1)' },
  { num: 2, color: 'var(--color-2)' },
  { num: 3, color: 'var(--color-3)' },
  { num: 4, color: 'var(--color-4)' },
  { num: 5, color: 'var(--color-5)' },
  { num: 6, color: 'var(--color-6)' },
  { num: 7, color: 'var(--color-7)' },
  { num: 8, color: 'var(--color-8)' },
  { num: 9, color: 'var(--color-9)' },
];

const IconChevron = ({ open }) => (
  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
    style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
    <path strokeLinecap="round" d="M19 9l-7 7-7-7" />
  </svg>
);
const IconCheck = () => (
  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" d="M5 13l4 4L19 7" />
  </svg>
);

export const FormulariPrincipal = () => {
  const [t]       = useTranslation('generic');
  const dispatch  = useDispatch();
  const navegacio = useNavigate();
  const [catOpen, setCatOpen]     = useState('1');
  const inicialitzat              = useRef(false);

  const { auth, configFormulario, ui, configUsuari } = useSelector((s) => s);
  const { infoFormulario, infoFormularioCategoria }   = configFormulario;

  useEffect(() => {
    if (inicialitzat.current) return;
    if (!infoFormulario) return;
    inicialitzat.current = true;
    dispatch(infoCategoria(auth.tokenJwt, infoFormulario.IdEvaluacion));
    dispatch(infoTextCategoria(auth.tokenJwt));
  }, [infoFormulario]);

  useEffect(() => {
    if (!infoFormularioCategoria) return;
    if (infoFormularioCategoria.CatActual != null) {
      setCatOpen(String(infoFormularioCategoria.CatActual));
    }
  }, []); 

  useEffect(() => {
    if (infoFormularioCategoria?.CatActual == null && infoFormularioCategoria != null) {
      dispatch(uiFinalitzarFormularioAction());
    }
  }, [infoFormularioCategoria]);

  // ── Netejar  errors amb timeout ───────────────────────────────────────────
  useEffect(() => {
    if (ui.msgError !== null) {
      const t = setTimeout(() => {
        dispatch(esborrarErrorAction());
        dispatch(esborrarOkAction());
      }, 10000);
      return () => clearTimeout(t);
    }
  }, [ui.msgError]);

  useEffect(() => {
    if (ui.formulari === false) {
      navegacio('/');
    }
  }, [ui.formulari]);

  const handleToggleCat = (num) => {
    dispatch(esborrarErrorAction());
    dispatch(infoCategoria(auth.tokenJwt, infoFormulario?.IdEvaluacion));
    setCatOpen(prev => prev === String(num) ? null : String(num));
  };

  const handleVolver = () => {
    dispatch(uiFinalitzarFormularioAction());
    navegacio('/');
  };

  if (!infoFormularioCategoria) return null;

  const completadas = CATS.filter(c => infoFormularioCategoria[`ResultatCat${c.num}Final`] != null).length;

  return (
    <div className="fp-wrapper">

      {/*  Tornar */}
      <button onClick={handleVolver} className="fp-btn-back">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
        </svg>
        Volver al historial
      </button>

      {/* Cabecera */}
      <div className="fp-header">
        <div>
          <p className="ca-label-super">{configUsuari.contingut.nombre_Mun}</p>
          <h2 className="fp-title">Formulario de evaluación</h2>
          <p className="ca-subtext">{completadas} de {CATS.length} categorías completadas</p>
        </div>
        <div className="fp-progress-wrap">
          <div className="fp-progress-bar">
            <div className="fp-progress-fill" style={{ width: `${(completadas / CATS.length) * 100}%` }} />
          </div>
          <span className="fp-progress-label">{Math.round((completadas / CATS.length) * 100)}%</span>
        </div>
      </div>

      {/* accordion */}
      <div className="fp-accordion">
        {CATS.map(({ num, color }) => {
          const resultadoFinal = infoFormularioCategoria[`ResultatCat${num}Final`];
          const isOpen  = catOpen === String(num);
          const isDone  = resultadoFinal != null;

          return (
            <div
              key={num}
              className={`fp-ac-item${isOpen ? ' fp-ac-item--open' : ''}${isDone ? ' fp-ac-item--done' : ''}`}
              style={{ '--cat-color': color }}
            >
              <button
                className="fp-ac-trigger"
                onClick={() => !isDone && handleToggleCat(num)}
                disabled={isDone}
              >
                <div className="fp-ac-left">
                  <span className="fp-ac-num" style={{ background: color + '18', color }}>
                    {isDone ? <IconCheck /> : num}
                  </span>
                  <span className="fp-ac-title">{t(`formulario.titleCat${num}`)}</span>
                </div>
                <div className="fp-ac-right">
                  {isDone ? (
                    <span className="fp-ac-score" style={{ color, background: color + '18', border: `1px solid ${color}33` }}>
                      {resultadoFinal}%
                    </span>
                  ) : (
                    <span className="fp-ac-chevron" style={{ color: isOpen ? color : '#9ca3af' }}>
                      <IconChevron open={isOpen} />
                    </span>
                  )}
                </div>
              </button>

              {isOpen && !isDone && (
                <div className="fp-ac-body">
                  <FormularioCat catNum={num} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};